import {
   Notification,
   NotificationMarkAsReadCommand,
   NotificationQuery,
   NotificationUnreadCountChangedEvent,
   NotificationUnreadCountQuery,
} from '@dreryk/egabinet-user-inbox-frontend-api';

import {
   refetchCqrsQuery,
   useCqrsCommand,
   UseCqrsCommandResult,
   useCqrsEvent,
   useCqrsGet,
   UseCqrsQueryResult,
   useCqrsSearch,
} from '@dreryk/command-query-react-common';

export type { Notification };

export const useNotifications = (): UseCqrsQueryResult<Notification[]> => {
   return useCqrsSearch<Notification>(() => new NotificationQuery());
};

export const useUnreadNotificationsCount = (): UseCqrsQueryResult<number> => {
   const result = useCqrsGet<number>(() => new NotificationUnreadCountQuery());

   useCqrsEvent<NotificationUnreadCountChangedEvent>(
      'egabinet-user-inbox-frontend-api:NotificationUnreadCountChangedEvent',
      (event) => {
         if (event.unreadCount > (result.data ?? 0)) {
            refetchCqrsQuery(NotificationQuery);
         }

         result.setData(event.unreadCount);
      }
   );

   return result;
};

export const useMarkNotificationsAsRead = (): UseCqrsCommandResult<void, number[]> => {
   return useCqrsCommand<void, number[]>((notificationIds) => {
      const command = new NotificationMarkAsReadCommand();
      command.notificationIds = notificationIds;

      return command;
   });
};
